export default __webpack_public_path__ + "static/media/presentation.145ae8da.pptx";